import React, { useEffect, useState } from 'react';
import { TailSpin } from 'react-loader-spinner';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import Chip from '@mui/material/Chip';

import SftGlobalData from '../library/SftGlobalData';
import Colors from '../library/Colors';

const ManualViewScreen = (props) =>  {  
    const [loading, setLoading] = useState(true);
    //const [title, setTitle] = useState("");
    const [htmlData, setHtmlData] = useState("<div></div>");
    const [versionInfo, setVersionInfo] = useState(null);
    const [isCustomerView, setIsCustomerView] = useState(false);
    let params = useParams();

    useEffect(()=>{
        let manualId = params.id + "";
        
        // Determine if this is a customer view (when customer parameter is present)
        const isCustomer = params.customer || props.login.sft_group === 'CUST';
        setIsCustomerView(isCustomer);
        
        SftGlobalData.post('docs&action=fetchManual', {
            sft_id: props.login.sft_id,
            sft_group: props.login.sft_group, 
            language: props.lang,
            login: props.login.login,
            id: manualId,
            customer: isCustomer ? 1 : 0  // Only show published versions for customers
        }).then(response => {
            // Check version info for internal users
            if (!isCustomer) {
                checkVersionInfo(manualId);
            }

            /*switch(props.lang){
                case "nl":
                    setTitle(response.data.title_nl);
                    break;
                case "fr":
                    setTitle(response.data.title_fr);
                    break;
                case "en":
                    setTitle(response.data.title_en);
                    break;
                default:
                    setTitle("");
                    break;
            }*/
            setHtmlData(response.data.detail[0].html)
            setLoading(false);
        });
    }, [props.api, props.login, params.id, props.lang]);
    
    const checkVersionInfo = (docId) => {
        // Fetch version information for internal users
        let postData = {
            sft_id: props.login.sft_id,
            sft_group: props.login.sft_group,
            login: props.login.login,
            doc_id: docId
        };
        SftGlobalData.post('docs&action=fetchVersionHistory', postData).then(response => { 
            if (response.data && response.data.length > 0) {
                // Get the latest version (first in array since ordered by version_number DESC)
                const latestVersion = response.data[0];
                setVersionInfo({
                    current_version: latestVersion.version_number,
                    status: latestVersion.status,
                    is_draft: latestVersion.status === 'DRAFT'
                });
            }
        }).catch(error => {
            if(SftGlobalData.debug){
                console.error('Error fetching version history:', error);
            }
            // Set default values on error
            setVersionInfo({
                current_version: 1,
                status: 'PUBLISHED',
                is_draft: false
            });
        });
    };

    return (
        <div  style={{height: "fit-content", paddingTop: 10, marginBottom: 10}} className={(props.screen === "logging" ? ('log__margin_sidebar log__container_content _80perc ' + props.theme + ' container_content_' + props.theme + '  box_fade-in') : (props.screenWidth) < 600 ? 'not_expanded container_content _80perc ' + props.theme + ' container_content_' + props.theme : 'expanded container_content _80perc ' + props.theme + ' container_content_' + props.theme)}>
            {/* Version indicator for internal users */}
            {!isCustomerView && versionInfo && (
                <div style={{marginBottom: 10, textAlign: 'right'}}>
                    <Chip 
                        label={`${props.t('version')} ${versionInfo.current_version} - ${props.t(versionInfo.status)}`}
                        color={versionInfo.is_draft ? "warning" : "success"}
                        size="small"
                    />
                </div>
            )}
            
            {loading && <div style={{display:"flex", justifyContent: "space-evenly", marginTop: 5}}>
                <TailSpin 
                    height="40"
                    width="40"
                    color={Colors.sft_blue}
                    ariaLabel='loading'
                />
            </div>}
            {!loading && <div style={{height: "fit-content"}} dangerouslySetInnerHTML={{__html: htmlData}}></div>}
        </div>
    );

}
export default ManualViewScreen;